import { Box, Heading, Text, List, ListItem } from '@chakra-ui/react'

const KeyComponents = () => (
  <Box>
    <Heading as="h4" size="md" mt={6} mb={2}>
      Key Components of the Strategy
    </Heading>
    <List spacing={3} mb={4}>
      <ListItem>
        <Text as="b">Good/Very Bad Ratio</Text>
        <List ml={4} spacing={1}>
          <ListItem><Text fontSize="sm"><b>Definition:</b> Number of "Good" sentiment indicators divided by "Very Bad" indicators</Text></ListItem>
          <ListItem><Text fontSize="sm"><b>Significance:</b> Values above 1.0 indicate positive market sentiment; below 1.0 indicate negative sentiment</Text></ListItem>
          <ListItem><Text fontSize="sm"><b>Calculation:</b> Good Count / Very Bad Count</Text></ListItem>
        </List>
      </ListItem>
      <ListItem>
        <Text as="b">Trend Strength</Text>
        <List ml={4} spacing={1}>
           <ListItem><Text fontSize="sm"><b>Purpose:</b> Confirms whether sentiment is consistently moving in one direction</Text></ListItem>
           <ListItem><Text fontSize="sm"><b>How to use:</b> Positive values strengthen buy signals; negative values strengthen sell signals</Text></ListItem>
           <ListItem><Text fontSize="sm"><b>Calculation:</b> Compare current ratio to previous days' values</Text></ListItem>
        </List>
      </ListItem>
      <ListItem>
        <Text as="b">Position Sizing</Text>
        <List ml={4} spacing={1}>
           <ListItem><Text fontSize="sm"><b>Standard allocation:</b> 75% of available capital</Text></ListItem>
           <ListItem><Text fontSize="sm"><b>Rationale:</b> Preserves some capital for future opportunities while capturing significant upside</Text></ListItem>
           <ListItem><Text fontSize="sm"><b>Risk management:</b> Never risk 100% of capital on any single trade</Text></ListItem>
        </List>
      </ListItem>
    </List>
  </Box>
)

export default KeyComponents
